/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcript_Export_Offset_Type_LabelInputs */

const en_transcript_export_offset_type_label = /** @type {(inputs: Transcript_Export_Offset_Type_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offset Type`)
};

const fr_transcript_export_offset_type_label = /** @type {(inputs: Transcript_Export_Offset_Type_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type de decalage`)
};

const de_transcript_export_offset_type_label = /** @type {(inputs: Transcript_Export_Offset_Type_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offset-Typ`)
};

const it_transcript_export_offset_type_label = /** @type {(inputs: Transcript_Export_Offset_Type_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo di offset`)
};

const ru_transcript_export_offset_type_label = /** @type {(inputs: Transcript_Export_Offset_Type_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тип смещения`)
};

const es_transcript_export_offset_type_label = /** @type {(inputs: Transcript_Export_Offset_Type_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo de desplazamiento`)
};

const zh_cn2_transcript_export_offset_type_label = /** @type {(inputs: Transcript_Export_Offset_Type_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`偏移类型`)
};

const ja_transcript_export_offset_type_label = /** @type {(inputs: Transcript_Export_Offset_Type_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オフセットタイプ`)
};

const hi_transcript_export_offset_type_label = /** @type {(inputs: Transcript_Export_Offset_Type_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑफसेट प्रकार`)
};

const pt_pt2_transcript_export_offset_type_label = /** @type {(inputs: Transcript_Export_Offset_Type_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo de deslocamento`)
};

/**
* | output |
* | --- |
* | "Offset Type" |
*
* @param {Transcript_Export_Offset_Type_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcript_export_offset_type_label = /** @type {((inputs?: Transcript_Export_Offset_Type_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcript_Export_Offset_Type_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_transcript_export_offset_type_label(inputs)
	if (locale === "de") return de_transcript_export_offset_type_label(inputs)
	if (locale === "it") return it_transcript_export_offset_type_label(inputs)
	if (locale === "ru") return ru_transcript_export_offset_type_label(inputs)
	if (locale === "es") return es_transcript_export_offset_type_label(inputs)
	if (locale === "zh-CN") return zh_cn2_transcript_export_offset_type_label(inputs)
	if (locale === "ja") return ja_transcript_export_offset_type_label(inputs)
	if (locale === "hi") return hi_transcript_export_offset_type_label(inputs)
	if (locale === "pt-PT") return pt_pt2_transcript_export_offset_type_label(inputs)
	return en_transcript_export_offset_type_label(inputs)
});